/* eslint semi:0 */
import { connect, } from 'react-redux'
import React, { Component, } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { isSameCalendarDay, } from '../../jsCore/utils/date'
import { DAY_IN_MILLISECONDS, } from '../../jsCore/utils/date'
import PreloadScores from './components/preloadScores'
import { t, } from '../../jsCore/providers/i18nProvider/i18nProvider'
import MatchItemScores from './components/matchItemScores'
import NoUpcomingMatches from './components/noUpcomingMatches'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { scheduleReducer, } from './scheduleReducer'
import { scheduleActions, } from './scheduleActions'
import ScheduleNavigationScores from './components/scheduleNavigationScores'


const STATE_KEY = "scheduleComponent"
const COMPONENT_NAME = "FixturesScheduleContainer"

function mapStateToProps(state){
  const {
    IS_INITIALIZED, matches, leagueName, scheduleDate, leagueChanged,
  } = state[STATE_KEY]
  return {
    matches,
    leagueName,
    IS_INITIALIZED,
    scheduleDate,
    leagueChanged,
  }
}

function getMatchItemScores(match, i){
  return <MatchItemScores key={ i } { ...match } />
}

function getMatchesToDisplay(matches){
  return matches.length ?
    matches.map(getMatchItemScores) :
    <NoUpcomingMatches message={ t('homepage.no_matches') } />
}

export class FixturesSchedule extends Component {

  constructor(props){
    super(props)
    this.onMoveToNextDayBound = this.onMoveToNextDay.bind(this)
    this.onMoveToPrevDayBound = this.onMoveToPrevDay.bind(this)
  }

  onMoveToNextDay(e){
    const { scheduleDate, changeScheduleDate, } = this.props
    const nextDay = new Date(scheduleDate.getTime() + DAY_IN_MILLISECONDS)
    changeScheduleDate(nextDay)
  }

  onMoveToPrevDay(e){
    const { scheduleDate, changeScheduleDate, } = this.props
    const prevDay = new Date(scheduleDate.getTime() - DAY_IN_MILLISECONDS)
    changeScheduleDate(prevDay)
  }

  render(){
    const { IS_INITIALIZED, matches, scheduleDate, leagueName, } = this.props
    if (!IS_INITIALIZED) {
      return <PreloadScores/>
    }
    const blockName = 'fixtures-schedule'
    const { leagueDayMatches: leagueMatches, } = matches.matchesByLeague.find(leagueData => leagueData.leagueName === leagueName)
    const minDate = leagueMatches && leagueMatches.length > 0 && leagueMatches[0].day
    const maxDate = leagueMatches && leagueMatches.length > 0 && leagueMatches[leagueMatches.length - 1].day
    const currentDayData = leagueMatches.find(
      dayEntry => isSameCalendarDay(dayEntry.day, scheduleDate)
    )
    const currentDayMatches = currentDayData ? currentDayData.matches : []
    const scheduleNavProps = {
      onMoveToNextDay: this.onMoveToNextDayBound,
      onMoveToPrevDay: this.onMoveToPrevDayBound,
      currentDay: scheduleDate,
      minDate,
      maxDate,
    }
    return (
      <div className={ `${ blockName }__container` }>
        <ScheduleNavigationScores { ...scheduleNavProps }
        />
        <div className={ `${ blockName }__matches-list` }>
          {
            getMatchesToDisplay(currentDayMatches)
          }
        </div>
      </div>
    )
  }

}

const FixturesScheduleContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, scheduleActions)(FixturesSchedule),
  reducer: scheduleReducer,
}

export default function mountFixturesSchedule(){
  return reduxMount({
    [MOUNT_POINTS.SCHEDULE_COMPONENT_IN_FIXTURES_PAGE]: FixturesScheduleContainer,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleScoresContainer.js